import qs from 'qs';

import type { Locale } from '@change-corgi/config/locales';
import { getTwitterHandle } from '@change-corgi/config/twitter';
import { openWindow } from '@change-corgi/core/window';
import type { TrackingFn } from '@change-corgi/core-react/tracking';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { truncate } from '#src/app/shared/utils/string';
import { isMobile } from '#src/app/shared/utils/userAgent';

import { trackShareSuccess } from './track';

type Options = {
	countryCode?: string;
	locale?: Locale;
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
	};
};

type ShareTwitterParams = {
	url: string;
	comment: string;
	options: Options;
	track: TrackingFn;
	utilityContext: UtilityContext;
};

export function shareTwitter({ url, comment, options, track, utilityContext }: ShareTwitterParams): void {
	const { countryCode, locale, trackingData, trackingEvents } = options;

	const params = {
		text: truncate(comment),
		url,
		via: getTwitterHandle({ countryCode: countryCode || 'US', locale }),
	};

	const baseUrl = isMobile(utilityContext) ? 'https://twitter.com/intent/tweet' : 'https://x.com/intent/post';
	const twitterUrl = `${baseUrl}?${qs.stringify(params, { encodeValuesOnly: true })}`;
	openWindow(twitterUrl);
	trackShareSuccess(trackingEvents.success, trackingData, track);
}
